import BaseComponent from '../../components/base-component/base-component'

const { Shopify } = window

class ProductModel extends BaseComponent {
  constructor() {
    super()

    this.poster = this.querySelector('[id^="Deferred-Poster-"]')
  }

  connectedCallback() {
    this.poster.addEventListener('click', this.handlePosterClick)

    if (this.carousel) {
      this.carousel.embla.on('select', this.handleCarouselSelect)
    }
  }

  disconnectedCallback() {
    this.poster.removeEventListener('click', this.handlePosterClick)

    if (this.carousel) {
      this.carousel.embla.off('select', this.handleCarouselSelect)
    }
  }

  handlePosterClick = () => {
    this.loadContent()
  }

  handleCarouselSelect = () => {
    if (this.carousel) {
      this.setCarouselDraggable(true)
    }
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      this.addModel()

      this.setAttribute('loaded', true)

      if (this.carousel) {
        this.setCarouselDraggable(false)
      }
    }

    Shopify.loadFeatures([
      {
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: this.setupModelViewerUI.bind(this),
      },
    ])
  }

  addModel() {
    const template = this.querySelector('template')

    if (!template || !template.content) {
      return
    }

    const templateContent = template.content
    const content = document.createElement('div')

    content.appendChild(templateContent.firstElementChild.cloneNode(true))
    const modelViewer = content.querySelector('model-viewer')

    this.appendChild(modelViewer)
  }

  setupModelViewerUI(errors) {
    if (errors) return

    this.modelViewerUI = new Shopify.ModelViewerUI(
      this.querySelector('model-viewer'),
    )
  }

  setCarouselDraggable(isDraggable) {
    const modelViewer = this.querySelector('.shopify-model-viewer-ui')

    this.carousel.dataset.draggable = isDraggable ? 'true' : 'false'
    this.carousel.reInit()

    if (isDraggable && modelViewer) {
      modelViewer.remove()

      this.removeAttribute('loaded')
    }
  }

  get carousel() {
    return this.closest('carousel-component')
  }
}

export default ProductModel

window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this),
      },
    ])
  },

  setupShopifyXR(errors) {
    if (errors) return

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () =>
        this.setupShopifyXR(),
      )
      return
    }

    document.querySelectorAll('[id^="ProductJSON-"]').forEach(modelJSON => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent))
      modelJSON.remove()
    })
    window.ShopifyXR.setupXRElements()
  },
}

window.addEventListener('DOMContentLoaded', () => {
  if (Shopify.designMode) {
    document
      .querySelectorAll('[data-shopify-xr-hidden]')
      .forEach(element => element.classList.add('hidden'))
  }
  if (window.ProductModel) window.ProductModel.loadShopifyXR()
})
